import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ButtonIconComponent } from './button-icon.component'
import { SvgModule } from '../../shared/svg/svg.module'

@NgModule({
  imports: [CommonModule, SvgModule],
  declarations: [ButtonIconComponent],
  exports: [ButtonIconComponent]
})
export class ButtonIconComponentModule {}
